/**
 * Bir formenin sorumlu olduğu parkları HİYERARŞİ temelli döndürür.
 *
 * Formenin "parkları", park görevlisinden farklı olarak parkın
 * `assigned_personnel_ids` cache'indeki DOĞRUDAN atamalar değildir; formenin
 * resmi bölgelerindeki (`region_ids`) parklardır.
 *
 * Neden gerekli: `assigned_personnel_ids` denormalize bir cache'tir ve geçmişte
 * bazı formen ID'leriyle (kimi formende tüm bölge parklarına, kiminde sadece
 * birkaçına, kiminde hiç) kirlenmiştir. Bu yüzden bu cache'i doğrudan sayan
 * yerler (kart rozeti, düzenle modalı) formenler arasında tutarsız "X Park"
 * değerleri üretiyordu. Bu fonksiyon, App.js'teki "Toplam" (allFormenParks)
 * hesabıyla birebir aynı mantığı tek yerde toplar.
 *
 * @param {object} person  Formen personeli (id, region_ids alanları kullanılır)
 * @param {Array}  parks   Tüm parklar
 * @param {Array}  personnel Tüm personel (astları bulmak için)
 * @returns {Array} Formenin sorumlu bölgelerindeki parklar
 */
export function getFormenRegionParks(person, parks, personnel) {
  if (!person) return [];
  const ownRegionIds = person.region_ids || [];
  const allParks = Array.isArray(parks) ? parks : [];
  const allPersonnel = Array.isArray(personnel) ? personnel : [];

  // Formenin doğrudan altındaki park görevlileri
  const subordinates = allPersonnel.filter(
    (p) =>
      p.formen_id === person.id ||
      (p.parent_id === person.id && p.role === 'park_gorevlisi')
  );

  // Adaylar: formenin cache'indeki parklar + astlarının atandığı parklar
  const ownParks = allParks.filter(
    (p) => p.assigned_personnel_ids && p.assigned_personnel_ids.includes(person.id)
  );
  const subordinateParks = allParks.filter(
    (park) =>
      park.assigned_personnel_ids &&
      subordinates.some((sub) => park.assigned_personnel_ids.includes(sub.id))
  );
  const candidate = [
    ...ownParks,
    ...subordinateParks.filter((p) => !ownParks.some((fp) => fp.id === p.id)),
  ];

  // Yalnızca formenin RESMİ bölgelerindeki parklar sayılır.
  return candidate.filter(
    (p) => p.region_id && ownRegionIds.includes(p.region_id)
  );
}
